import { AppSetting } from '../AppSetting';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { BaseService } from '../Service/BaseService';
import { AppSettingApi } from '../AppSettingApi';



/**
 * PaymentDAO
 * 請求系DAO
 */
export class PaymentDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}

	/**
	 * getPaymentList
	 * 請求リストの取得
	 * @returns 請求一覧
	 */
	public async getPaymentList() {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.PAYMENT_LIST, request);
		return ret;

	}

	/**
	 * 請求詳細の取得
	 * @param payment_id 請求ID
	 * @returns 請求詳細
	 */
	public async getPaymentDetail(payment_id: number) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token,
			payment_id
		};

		const ret = await this.postRequest(AppSettingApi.PAYMENT_DETAIL, request);
		return ret;

	}


}
